import { IDevice, setDeviceId, updateDevice } from 'core'

type IClientDevice = Omit<IDevice, 'id'>

let hasSetClientDevice = false
let clientDevice: IClientDevice | null
let serverDevice: IDevice | null = null

export const getClientDevice = async (): Promise<IClientDevice | null> => {
  if (!hasSetClientDevice) {
    throw new Error('getClientDevice called before being set')
  }

  return clientDevice
}

const syncDeviceState = async () => {
  if (!clientDevice || !serverDevice) {
    return
  }

  const { hasNotificationPermission, notificationPermissionState } = clientDevice

  if (
    serverDevice.hasNotificationPermission !== hasNotificationPermission ||
    serverDevice.notificationPermissionState !== notificationPermissionState
  ) {
    const results = await updateDevice(serverDevice.id, {
      hasNotificationPermission,
      notificationPermissionState
    })

    if (results.success) {
      serverDevice = results.device
    }
  }
}

export const setClientDevice = async (device: IClientDevice | null) => {
  hasSetClientDevice = true
  clientDevice = device

  if (clientDevice && !serverDevice) {
    setDeviceId(`os:${clientDevice.oneSignalId}`)
  }

  await syncDeviceState()
}

export const setServerDevice = async (device: IDevice | null) => {
  serverDevice = device

  if (device) {
    setDeviceId(device.id)
  }

  await syncDeviceState()
}
